export const SESSION_EXPIRED_EVENT = "sessionExpired";
